module.exports = __webpack_public_path__ + "img/kqLogo.5abeda5d.png";